<template>
  <div class="view-module">
    <action-dispatcher
      action="modules/getDetails"
      :parameters="$route.params.id"
      ref="modulesDispatcher"
    >
      <header-preview
        :module="moduleData"
        :additional-info="headerModuleInfo"
        :description="moduleData.description"
        :lesson="currentLesson"
        show-progress
        back-button
      />
      <action-dispatcher
        action="lessons/getAll"
        :parameters="$route.params.id"
        class="view-module"
      >
        <div class="container-fluid pt-5">
          <template v-if="items.length">
            <h4 class="section-title">
              Conteúdo
            </h4>

            <lessons-quiz-list :items="items" />
          </template>

          <h4
            v-if="module.sub_modules && module.sub_modules.length"
            class="section-title"
          >
            Submódulos
          </h4>

          <div v-if="empty" class="d-flex justify-content-center mt-5 pt-5">
            <empty-icon />
          </div>

          <home-carousel :list="module.sub_modules">
            <template #default="{ data }">
              <module-card class="flex-fill" :module="data" />
            </template>
          </home-carousel>
        </div>
      </action-dispatcher>
    </action-dispatcher>
  </div>
</template>

<script>
import HeaderPreview from "@/components/preview/HeaderPreview";
import HomeCarousel from "@/components/home/HomeCarousel";
import LessonsQuizList from "@/components/module/LessonsQuizList";
import ModuleCard from "@/components/home/ModuleCard";
import EmptyIcon from "@/assets/vueIcons/EmptyIcon";
import { mapState } from "vuex";
import get from "lodash/get";

export default {
  components: {
    LessonsQuizList,
    HeaderPreview,
    HomeCarousel,
    EmptyIcon,
    ModuleCard
  },
  computed: {
    ...mapState("modules", ["module"]),
    ...mapState("lessons", ["lessons"]),
    ...mapState("quiz", ["quizes"]),
    moduleData() {
      return {
        ...this.module,
        cover: this.module.header
      };
    },
    submodules() {
      const list = (this.module.sub_modules ?? []).filter(
        m => m.status === "published"
      );
      return list.sort((a, b) => a.sort - b.sort);
    },
    all_lessons_duration() {
      if (!this.lessons || this.lessons.length == 0) return 0;

      return this.lessons.reduce((acc, cur) => acc + Number(cur.duration), 0);
    },
    headerModuleInfo() {
      const time = get(this.module, "duration", this.all_lessons_duration);
      const hours = Math.floor(time / 60);
      const duration = hours > 0 ? `${hours}h de duração • ` : "";
      const submodule_info = this.submodules.length
        ? ` • ${this.submodules.length} submódulo${
            this.submodules.length == 1 ? "" : "s"
          }`
        : "";
      return `${duration}${this.lessons.length} aula${
        this.lessons.length == 1 ? "" : "s"
      }${submodule_info}`;
    },
    items() {
      return [...this.lessons, ...this.quizes].sort((a, b) => a.sort - b.sort);
    },
    currentLesson() {
      return (
        this.lessons &&
        this.lessons.find(
          lesson => !lesson.progress || !lesson.progress.finished_at
        )
      );
    },
    numLessons() {
      return get(this.module, "lessons.length", 0);
    },
    category() {
      return get(this.module, "lessons[0].category.name", "");
    },
    moduleInfo() {
      // const time = get(this.module, "submodule_time", "0");
      // return `${time}h de duração • ${this.lessons.length} aulas`;
      return `${this.lessons.length} aulas`;
    },
    empty() {
      return !this.module.sub_modules?.length && !this.items.length;
    }
  },
  methods: {
    dispatchQuizzes() {
      this.$store
        .dispatch("quiz/getAll", {
          module_id: this.$route.params.id,
          params: { limit: 1000, status: "published" }
        })
        .then();
    }
  },
  mounted() {
    this.dispatchQuizzes();
  }
};
</script>

<style lang="scss" scoped>
.view-module {
  padding-top: 72px;

  .section-title {
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: 150%;
  }

  ::v-deep {
    .VueCarousel-navigation-next {
      transform: translateX(50%) translateY(-120%);
    }
    .VueCarousel-navigation-prev {
      transform: translateX(-100%) translateY(-120%);
      @media screen and (max-width: 991px) {
        transform: translateX(-50%) translateY(-120%);
      }
    }
  }
}
</style>
